var gal,
    controls,
    helpers,
    fav,
    mediaQueries,
    globalEventListeners,
    copySubscribe,
    relatedScroll,
    subscribeV2,
    //popups,
    navigation,
    wordPopup,
    mzView,
    viewAd,
    pinZones,
    viewAsyncAdDesktop,
    isRedesign = $('.vr-slider-body').length > 0;


$(document).ready(function() {
    "use strict";
    gal = new BrochureView();
    helpers = new Helpers(gal);
    //popups = new Popups();
    mzView = new ModernizrView(gal);
    viewAsyncAdDesktop = new ViewAsyncAdDesktop();

    if(typeof pagePromotionSettings !== 'undefined'){
        var campRedirect = new CampRedirect(pagePromotionSettings);
        campRedirect.init();
    }
    
    //popups.init();

    gal.init();


    helpers.initBurgerButton();
    helpers.toggleLoader(1, 0);

    if(isMobile == false){
        relatedScroll = new RelatedScroll(gal);
        // relatedScroll.init();
    }

    // $(document).on('view.gallery.inited', function(){
    // window.addEventListener('view.page.subscribe.copied', function(e) {
    //     subscribeV2 = new SubscribeV2();
    //     subscribeV2.initMagnificItems();
    // });
    
    copySubscribe = new CopySubscribe(gal);
    copySubscribe.init();
    
    document.addEventListener('view.gallery.inited', function(e) {
        helpers.toggleLoader(0);
        // console.log('initView view.gallery.inited');

        controls = new Controls(gal);
        controls.init();

        fav = new Fav(gal.gallery);
        fav.events();
        controls.initControlButtons();

        globalEventListeners = new GlobalEventListeners(gal);
        globalEventListeners.init();

        if(isMobile){
            navigation = new Navigation(gal);
            navigation.init();
        }

        viewAd = new ViewAd(gal);
        // viewAd.init();
    });

    window.addEventListener('view.initialZoomInEnd', function(e) {
        mediaQueries = new MediaQueries(gal);
        mediaQueries.init();

        helpers.renderFix();
    });
});